import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer, createMigrate } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import voiceEntryReducer from '../voiceEntry/voiceEntryReducer';
import cameraEntryReducer from '../cameraEntry/cameraEntryReducer';
import roomBookingReducer from '../roomBooking/roomBookingReducer';
import Layout from '../layout/reducers';
import Login from '../auth/authReducer'; // Import your auth reducer
import PageTitle from '../pageTitle/reducers';
import uiChatReducer from '../uiChatReducer/uiChatReducer';
import bookingAvailabilityReducer from '../bookingAvailability/bookingAvailabilityReducer';
import hotelReducer from '../hotel/hotelReducer';
import hotelStaffReducer from '../hotelStaff/hotelStaffReducer';
// import maiActionsReducer from '../maiAction/maiActionReducer'
// import contactReducer from '../contacts/contactReducer';
// import debugLogsReducer from '../DebugLogs/debugLogsReducer';
// import actionsReducer from '../reducers/actionsReducer'; // Import your actions reducer

// 🔥 Force persist after successful login
const migrations = {
    1: (state) => {
        // This will be called if the current version is > version in localStorage
        console.log("Running migration v1: resetting Auth");
        return {
            ...state,
            // Auth: undefined, // or INIT_STATE if you want
        };
    },
};
const persistConfig = {
    key: 'root',
    version: 3,
    storage,
    // whitelist: ['Auth'],
    blacklist: [
        'Action',
        'Auth',
        'Contact',
        'DebugLogs',
        'Layout',
        'voiceEntry',
        'roomBooking',
        'cameraEntry',
        'uiChat',
        'bookingAvailabilityReducer',
        'hotel',
        'hotelStaff'
    ],  //['Action','Auth','Contact'], // Don't persist the actions reducer 
    migrate: createMigrate(migrations, { debug: true }),
};

const rootReducer = combineReducers({
    Auth: Login,
    Layout: Layout,
    PageTitle: PageTitle,
    // Action: maiActionsReducer,
    // Contact: contactReducer,
    // DebugLogs: debugLogsReducer,
    // // actions: actionsReducer,
    voiceEntry: voiceEntryReducer,
    cameraEntry: cameraEntryReducer,
    roomBooking: roomBookingReducer,
    uiChat: uiChatReducer,
    bookingAvailabilityReducer: bookingAvailabilityReducer,
    hotel: hotelReducer,
    hotelStaff: hotelStaffReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default persistedReducer;
